import { render, staticRenderFns } from "./pdfs-solicitud-posgrado.vue?vue&type=template&id=861e10b8&"
import script from "./pdfs-solicitud-posgrado.component.ts?vue&type=script&lang=ts&"
export * from "./pdfs-solicitud-posgrado.component.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports